import {SessionStorage} from '@/ts/utils/session-storage';

/** Singleton SessionStorage instance backed by the browser's sessionStorage. */
export const sessionStorage: SessionStorage = new SessionStorage();
